<template>
  <div
    v-element-loader="{ endpoint: 'order' }"
    class="my-pages">
    <validation-observer
      ref="observer"
      tag="form">
      <div class="my-pages__content-grid order-return__top-grid">
        <div class="input-column">
          <div class="my-pages__actions">
            <div class="my-pages-template__action">
              <oie-base-action theme="flat" @click="goBack">
                <template #iconPrepend>
                  <oie-base-icon icon="arrow-left" size="s"></oie-base-icon>
                </template>
                {{ tStatic('goBack') }}
              </oie-base-action>
            </div>

            <!--
            <a :href="clientModel.orderHistoryUrl" class="navigational-item navigational-item--arrow navigational-item--white navigational-item--tab">
              {{ tStatic('orderHistoryMenuItem') }}
            </a>
              -->
          </div>
        </div>

        <div class="input-column">
          <div>
            <h2 v-epi-edit="'OrderHistoryHeader'" class="my-pages__page-type-header">
              {{ t('orderReturnHeader') }}
            </h2>
          </div>
        </div>
      </div>

      <div class="grid grid--three history-details__information">
        <div class="history-details__information-box">
          <h3
            v-epi-edit="'orderInformationHeader'"
            class="history-details__information-header">
            {{ t("orderInformationHeader") }}
            <!-- Ordernummer information -->
          </h3>

          <div class="history-details__information-details">
            <div class="history-details__information-details-row">
              <div v-epi-edit="'orderNumberLabel'" class="history-details__information-details-key">
                {{ t("orderNumberLabel") }}
              </div>
              <div class="history-details__information-details-value">
                {{ order.orderHead.orderNr }}
              </div>
            </div>

            <div class="history-details__information-details-row">
              <div
                v-epi-edit="'orderDateLabel'"
                class="history-details__information-details-key">
                {{ t("orderDateLabel") }}
                <!-- BestÃ¤llningssatum: -->
              </div>
              <div class="history-details__information-details-value">
                {{ order.orderHead.displayOrderDate }}
              </div>
            </div>
          </div>
        </div>

        <div v-if="orderReturn.issueKey" class="history-details__information-box">
          <h3
            v-epi-edit="'orderInformationHeader'"
            class="history-details__information-header">
            {{ t("returnComplaintHeading") }}
          </h3>

          <div class="history-details__information-details">
            <div class="history-details__information-details-row">
              <div v-epi-edit="'orderNumberLabel'" class="history-details__information-details-key">
                {{ t("issueKeyLabel") }}
              </div>
              <div class="history-details__information-details-value">
                <span v-if="!orderReturn.isSuperUser">{{ orderReturn.issueKey }}</span>
                <span v-if="orderReturn.isSuperUser"><a target="_blank" :href="'https://olssonparts.atlassian.net/jira/servicedesk/projects/CS/queues/custom/78/' + encodeURIComponent(orderReturn.issueKey)">{{ orderReturn.issueKey }}</a></span>
              </div>
            </div>

            <div class="history-details__information-details-row">
              <div
                v-epi-edit="'orderDateLabel'"
                class="history-details__information-details-key">
                {{ t("statusLabel") }}
              </div>
              <div class="history-details__information-details-value">
                {{ orderReturn.statusName }}
              </div>
            </div>

            <div v-if="orderReturn.rma !== null && orderReturn.rma !== ''" class="history-details__information-details-row">
              <div
                v-epi-edit="'orderDateLabel'"
                class="history-details__information-details-key">
                {{ t("rmaLabel") }}
              </div>
              <div class="history-details__information-details-value">
                {{ orderReturn.rma }}
              </div>
            </div>

            <div v-if="orderReturn.consignmentNoteUrl != null && orderReturn.consignmentNoteUrl != ''" class="history-details__information-details-row">
              <div
                v-epi-edit="'orderDateLabel'"
                class="history-details__information-details-key">
                {{ t("returnAddressCardLabel") }}
              </div>
              <div class="history-details__information-details-value">
                <a :href="orderReturn.consignmentNoteUrl">Ladda ner</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <oie-message-box v-if="showGeneralErrorMessage" class="message-box--orange message-box--compact order-return-message">
          <svg
            width="22px"
            height="22px"
            viewBox="0 0 32 33"
            aria-labelledby=""
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            class="message-bar__icon svg">
            <title id="" lang="sv"> icon</title>
            <g fill="currentColor" fill-rule="evenodd" class="svg__color"><path d="M21 24.49H11v-3.143h3.333v-4.714h-1.666V13.49H16c.922 0 1.667.704 1.667 1.571v6.286H21v3.143zm-5-17a2 2 0 1 1-.001 4.001A2 2 0 0 1 16 7.49zm0-7c-8.822 0-16 7.179-16 16 0 8.824 7.178 16 16 16s16-7.176 16-16c0-8.821-7.178-16-16-16z" fill-rule="evenodd" /></g>
          </svg>
          <span v-html="t('generalErrorMessage')"></span>
        </oie-message-box>
      </div>

      <div>
        <oie-message-box v-if="!showGeneralErrorMessage && !orderReturn.returnsPossible && orderReturn.issueKey === null" class="message-box--orange message-box--compact order-return-message">
          <svg
            v-if="mq('small')"
            width="22px"
            height="22px"
            viewBox="0 0 32 33"
            aria-labelledby=""
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            class="message-bar__icon svg">
            <title id="" lang="sv"> icon</title>
            <g fill="currentColor" fill-rule="evenodd" class="svg__color"><path d="M21 24.49H11v-3.143h3.333v-4.714h-1.666V13.49H16c.922 0 1.667.704 1.667 1.571v6.286H21v3.143zm-5-17a2 2 0 1 1-.001 4.001A2 2 0 0 1 16 7.49zm0-7c-8.822 0-16 7.179-16 16 0 8.824 7.178 16 16 16s16-7.176 16-16c0-8.821-7.178-16-16-16z" fill-rule="evenodd" /></g>
          </svg>
          {{ t('returnsNotPossibleDescription') }}
        </oie-message-box>
      </div>

      <div>
        <oie-message-box v-if="!showGeneralErrorMessage && !orderReturn.complaintReturnsPossible && orderReturn.issueKey === null" class="message-box--orange message-box--compact order-return-message">
          <svg
            v-if="mq('small')"
            width="22px"
            height="22px"
            viewBox="0 0 32 33"
            aria-labelledby=""
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            class="message-bar__icon svg">
            <title id="" lang="sv"> icon</title>
            <g fill="currentColor" fill-rule="evenodd" class="svg__color"><path d="M21 24.49H11v-3.143h3.333v-4.714h-1.666V13.49H16c.922 0 1.667.704 1.667 1.571v6.286H21v3.143zm-5-17a2 2 0 1 1-.001 4.001A2 2 0 0 1 16 7.49zm0-7c-8.822 0-16 7.179-16 16 0 8.824 7.178 16 16 16s16-7.176 16-16c0-8.821-7.178-16-16-16z" fill-rule="evenodd" /></g>
          </svg>
          {{ t('complaintReturnsNotPossibleDescription') }}
        </oie-message-box>
      </div>

      <div>
        <oie-message-box v-if="!showGeneralErrorMessage && orderReturn.issueKey && !creatingRma && !orderReturn.rma && !orderReturn.handleShippingMyself" class="message-box--green message-box--compact order-return-message">
          <svg
            width="22px"
            height="22px"
            viewBox="0 0 32 33"
            aria-labelledby=""
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            class="message-bar__icon svg">
            <title id="" lang="sv"> icon</title>
            <g fill="currentColor" fill-rule="evenodd" class="svg__color"><path d="M21 24.49H11v-3.143h3.333v-4.714h-1.666V13.49H16c.922 0 1.667.704 1.667 1.571v6.286H21v3.143zm-5-17a2 2 0 1 1-.001 4.001A2 2 0 0 1 16 7.49zm0-7c-8.822 0-16 7.179-16 16 0 8.824 7.178 16 16 16s16-7.176 16-16c0-8.821-7.178-16-16-16z" fill-rule="evenodd" /></g>
          </svg>
          <span v-html="(t('orderReturnConfirmationDescription') || '').replace('{IssueKey}', orderReturn.issueKey)"></span>
        </oie-message-box>
      </div>

      <div>
        <oie-message-box v-if="!showGeneralErrorMessage && orderReturn.issueKey && orderReturn.handleShippingMyself" class="message-box--green message-box--compact order-return-message">
          <svg
            width="22px"
            height="22px"
            viewBox="0 0 32 33"
            aria-labelledby=""
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            class="message-bar__icon svg">
            <title id="" lang="sv"> icon</title>
            <g fill="currentColor" fill-rule="evenodd" class="svg__color"><path d="M21 24.49H11v-3.143h3.333v-4.714h-1.666V13.49H16c.922 0 1.667.704 1.667 1.571v6.286H21v3.143zm-5-17a2 2 0 1 1-.001 4.001A2 2 0 0 1 16 7.49zm0-7c-8.822 0-16 7.179-16 16 0 8.824 7.178 16 16 16s16-7.176 16-16c0-8.821-7.178-16-16-16z" fill-rule="evenodd" /></g>
          </svg>
          <span v-html="(t('orderReturnConfirmationHandleShippingMyself') || '').replace('{IssueKey}', orderReturn.issueKey)"></span>
        </oie-message-box>
      </div>

      <div>
        <oie-message-box v-if="!showGeneralErrorMessage && orderReturn.issueKey && orderReturn.shippingQuoteRequested === 'Kunden har BEGÄRT OFFERT för returfrakt'" class="message-box--green message-box--compact order-return-message">
          <svg
            width="22px"
            height="22px"
            viewBox="0 0 32 33"
            aria-labelledby=""
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            class="message-bar__icon svg">
            <title id="" lang="sv"> icon</title>
            <g fill="currentColor" fill-rule="evenodd" class="svg__color"><path d="M21 24.49H11v-3.143h3.333v-4.714h-1.666V13.49H16c.922 0 1.667.704 1.667 1.571v6.286H21v3.143zm-5-17a2 2 0 1 1-.001 4.001A2 2 0 0 1 16 7.49zm0-7c-8.822 0-16 7.179-16 16 0 8.824 7.178 16 16 16s16-7.176 16-16c0-8.821-7.178-16-16-16z" fill-rule="evenodd" /></g>
          </svg>
          <span v-html="(t('orderReturnShippingQuoteRequested') || '').replace('{IssueKey}', orderReturn.issueKey)"></span>
        </oie-message-box>
      </div>

      <div>
        <oie-message-box v-if="!showGeneralErrorMessage && orderReturn.rma" class="message-box--green message-box--compact order-return-message">
          <svg
            width="22px"
            height="22px"
            viewBox="0 0 32 33"
            aria-labelledby=""
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            class="message-bar__icon svg">
            <title id="" lang="sv"> icon</title>
            <g fill="currentColor" fill-rule="evenodd" class="svg__color"><path d="M21 24.49H11v-3.143h3.333v-4.714h-1.666V13.49H16c.922 0 1.667.704 1.667 1.571v6.286H21v3.143zm-5-17a2 2 0 1 1-.001 4.001A2 2 0 0 1 16 7.49zm0-7c-8.822 0-16 7.179-16 16 0 8.824 7.178 16 16 16s16-7.176 16-16c0-8.821-7.178-16-16-16z" fill-rule="evenodd" /></g>
          </svg>
          <span v-html="(t('rmaCreatedMessage') || '').replace('{RMA}', orderReturn.rma)"></span>
        </oie-message-box>
      </div>
      <div v-if="false && ((selectedReturnRows.some(item => item.returnReasonId === 1) || orderReturn.fullOrderReturnReasonID === 1))" class="order-return-repayment-info" v-html="t('repaymentDescription')"></div>
      <oie-base-accordion-toggler
        v-if="orderReturn.issueKey !== null"
        :is-open="isReturnActionsOpen"
        :text="t('orderReturnNewReturnButtonText')"
        class="new-return__toggler"
        @click="createNewReturn()">
      </oie-base-accordion-toggler>
      <div v-if="isReturnActionsOpen" class="order-return-container__return-options">
        <div class="order-return-container__return-options-container">
          <h2 class="order-return-container__section-heading">
            {{ t('selectArticlesHeading')
            }}
          </h2>

          <div class="order-return-container__radio-buttons">
            <oie-base-radio
              v-for="method in returnOptions"
              :id="`${method.id}_i`"
              :key="method.id"
              :value="String(method.id)"
              :is-checked="returnOptionID === method.id"
              :label-text="`${method.name}`"
              :use-sub-text="true"
              css-classes="radio--blue"
              name="shipping-type"
              @click="setReturnOptionID(method.id)">
              <span class="radio__label-sub-text-container">
                {{ method.description }}
              </span>
            </oie-base-radio>
          </div>
        </div>

        <div v-if="returnOptionID === 1" class="order-return-container__full-order">
          <div class="input-column">
            <div class="input-column__container">
              <validation-provider
                v-if="returnOptionID === 1"
                name="full-order-return-reason"
                rules="required"
                slim>
                <template slot-scope="{ errors }">
                  <oie-base-dropdown
                    v-model="orderReturn.fullOrderReturnReasonID"
                    :initial-text="tStatic('orderReturnReasonDropdownText')"
                    :options="orderReturnReasonOptions"
                    :is-large="false"
                    :use-full-width="true"
                    :use-thin-border="true"
                    :label-text="t('reasonLabel')"
                    :error-message="errors[0]"></oie-base-dropdown>
                </template>
              </validation-provider>

              <validation-provider
                v-if="orderReturn.fullOrderReturnReasonID"
                name="full-order-return-description"
                :rules="orderReturn.fullOrderReturnReasonID !== 1 ? 'required' : ''"
                slim>
                <template slot-scope="{ errors }">
                  <oie-base-input
                    v-show="orderReturn.fullOrderReturnReasonID"
                    id="fullOrderReturnReason"
                    v-model="orderReturn.fullOrderReturnReasonDescription"
                    :textarea="true"
                    :max-length="2000"
                    :label-text="t('fullOrderReturnDescriptionLabel')"
                    :placeholder="getReturnReasonDescriptionPlaceholder(orderReturn.fullOrderReturnReasonID)"
                    :error-messages="errors"></oie-base-input>
                </template>
              </validation-provider>

              <validation-provider
                :name="`machine-type-${key}`"
                :rules="orderReturn.fullOrderReturnReasonID !== 1 && orderReturn.fullOrderReturnReasonID !== 6? 'required' : ''"
                slim>
                <template slot-scope="{ errors }">
                  <oie-base-input
                    v-show="orderReturn.fullOrderReturnReasonID === 3 || orderReturn.fullOrderReturnReasonID === 4 || orderReturn.fullOrderReturnReasonID === 5"
                    v-model="orderReturn.fullOrderReturnMachineType"
                    :label-text="t('vehicleTypeLabel')"
                    :placeholder="tStatic('orderReturnMachineTypePlaceholder')"
                    :error-messages="errors"></oie-base-input>
                </template>
              </validation-provider>

              <validation-provider
                :name="`serial-number-${key}`"
                :rules="orderReturn.fullOrderReturnReasonID !== 1 && orderReturn.fullOrderReturnReasonID !== 6? 'required' : ''"
                slim>
                <template slot-scope="{ errors }">
                  <oie-base-input
                    v-show="orderReturn.fullOrderReturnReasonID === 3 || orderReturn.fullOrderReturnReasonID === 4 || orderReturn.fullOrderReturnReasonID === 5"
                    v-model="orderReturn.fullOrderReturnSerialNumber"
                    :label-text="t('serialNumberLabel')"
                    :placeholder="tStatic('orderReturnSerialNumberPlaceholder')"
                    :error-messages="errors"></oie-base-input>
                </template>
              </validation-provider>
            </div>
          </div>
        </div>
      </div>

      <div v-if="returnOptionID === 2 && isReturnActionsOpen && (orderReturn.returnsPossible || orderReturn.complaintReturnsPossible)" class="history-details-products">
        <!--
        <div v-epi-edit="'orderRowsHeader'" class="history-details-products__top">
          {{ t("orderRowsHeader") }}
        </div>
          -->

        <oie-customer-order-return-product-table
          v-if="isReturnActionsOpen"
          :order-return="orderReturn"
          :rows="order.orderRows"
          :returns-possible="orderReturn.returnsPossible"
          :complaint-returns-possible="orderReturn.complaintReturnsPossible"
          :is-super-user="orderReturn.isSuperUser"
          class="order-return-container_products"></oie-customer-order-return-product-table>
      </div>

      <div v-if="isReturnActionsOpen && (orderReturn.returnsPossible || orderReturn.complaintReturnsPossible)" class="history-details-products">
        <h2 class="order-return-container__section-heading">
          {{ t("attachImagesOrVideoHeading") }}
        </h2>

        <oie-order-return-file-upload
          :order-number="orderNumber"
          :required="isUploadedImageRequired"
          :token="token"
          class="order-return-container__order-return-file-upload"></oie-order-return-file-upload>
      </div>

      <div v-if="false && isReturnActionsOpen" class="order-return-repayment">
        <div>
          <h2 v-epi-edit="'OrderReturnStatusHeading'" class="order-return-container__section-heading">
            {{ t('orderReturnRepaymentHeading') }}
          </h2>

          <oie-base-dropdown
            v-if="false"
            v-model="repaymentOptionID"
            :initial-text="tStatic('orderReturnRepaymentDropdownText')"
            :options="repaymentOptions"
            :is-large="false"
            :is-for="`history-details-product-${key}`"
            :block-id="`history-details-product-${key}`"
            :use-full-width="true"
            :use-thin-border="true"
            :default-selected="defaultRepaymentOption"></oie-base-dropdown>

          <validation-provider
            v-if="false && repaymentOptionID === '2'"
            name="bank-account-number"
            rules="required"
            slim>
            <template slot-scope="{ errors }">
              <oie-base-input
                v-show="repaymentOptionID === '2'"
                id="bank-account-number"
                v-model="repaymentBankAccountNumber"
                :placeholder="tStatic('orderReturnRepaymentBankAccountNumberPlaceholder')"
                :error-messages="errors"></oie-base-input>
            </template>
          </validation-provider>
        </div>
      </div>

      <oie-order-return-contact-info v-if="isReturnActionsOpen" :order-number="orderNumber" :token="token"></oie-order-return-contact-info>
    </validation-observer>

    <div v-if="isReturnActionsOpen && dontShowReturnShipping" class="order-return-container__actions-container">
      <div class="order-return-container__actions-right">
        <oie-base-button
          v-epi-edit="'createOrderReturnButtonLabel'"
          :text="t('addToCartButtonLabel')"
          :disabled="orderReturn.fullOrderReturnReasonID == null && selectedReturnRows.length === 0"
          css-classes="button--with-border button--green order-return-container__action-button"
          :use-full-width="true"
          @click="createOrderReturn"></oie-base-button>
      </div>
    </div>

    <h2
      v-show="isReturnActionsOpen && !dontShowReturnShipping"
      class="order-return-container__section-heading">
      {{ t("createRmaLabel") }}
    </h2>

    <oie-customer-order-return-rma
      v-show="isReturnActionsOpen && !dontShowReturnShipping"
      :issue-key="orderReturn.issueKey"
      :order-number="orderNumber"
      :token="token"
      :create-rma-along-with-issue="createRmaAlongWithIssue"></oie-customer-order-return-rma>

    <div v-if="!isReturnActionsOpen && orderReturn.issueKey" class="history-details-products">
      <oie-order-return-issue-tracking
        :rows="issueMessages"
        :order-return="orderReturn"
        :order="order"
        class="history-details-products__table"></oie-order-return-issue-tracking>
    </div>
  </div>
</template>

<script>
import httpService from '@/core/http-service'
import _ from 'lodash'

export default {
  props: {
    orderNumber: {
      type: String,
      default: ''
    },
    token: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    showGeneralErrorMessage: false,
    creatingRma: false,
    createRmaAlongWithIssue: true,
    isReturnActionsOpen: false,
    isSuperuserSectionOpen: false,
    repaymentOptionID: null,
    repaymentBankAccountNumber: null,
    selectedReturnRows: [],
    issueMessages: [],
    customerRepresentativeFirstName: null,
    orderReturn: {
      issueKey: null,
      statusName: '',
      isBillableClient: false,
      returnsPossible: true,
      complaintReturnsPossible: true,
      orderReturnIssue: null,
      isSuperUser: false,
      fullOrderReturnReasonID: null,
      fullOrderReturnReasonDescription: null,
      fullOrderReturnMachineType: null,
      fullOrderReturnSerialNumber: null,
      uploadedFiles: [],
      shippingCost: 0,
      shippingKey: null,
      shippingAgent: null,
      shippingAgentService: null,
      documentToCustomer: null,
      rma: null,
      consignmentNoteUrl: null,
      handleShippingMyself: false,
      shippingQuoteRequested: null
    },
    returnOptions: [],
    returnOptionID: 2,
    order: {
      orderHead: {
        orderNr: '',
        orderDate: '',
        displayOrderDate: '',
        customerNo: '',
        currency: '',
        paymentTerms: '',
        modeOfDelivery: '',
        shipmentId: '',
        ourRef: '',
        invoiceRefernce: '',
        shipmentCost: 0,
        packagingCost: 0,
        vatSum: 0,
        orderSum: 0,
        comment: '',
        goodsInformationNo: '',
        goodsInformationUrl: '',
        deliveryAddress: {
          name: '',
          address1: '',
          address2: '',
          zipCode: '',
          city: '',
          country: ''
        },
        invoiceAddress: {
          name: '',
          address1: '',
          address2: '',
          zipCode: '',
          city: '',
          country: ''
        }
      },
      orderRows: []
    }
  }),
  computed: {
    repaymentOptions() {
      return [
        { text: this.tStatic('orderReturnRepaymentDropdownOption1'), value: '1' },
        { text: this.tStatic('orderReturnRepaymentDropdownOption2'), value: '2' }
      ]
    },
    orderReturnReasonOptions() {
      let reasons = []

      if (this.orderReturn.returnsPossible || this.orderReturn.isSuperUser) {
        reasons.push({ text: this.t('orderReturnReasonDropdownOption1'), value: 1 })
        reasons.push({ text: this.t('orderReturnReasonDropdownOption2'), value: 2 })
        reasons.push({ text: this.t('orderReturnReasonDropdownOption3'), value: 3 })
      }

      if (this.orderReturn.complaintReturnsPossible || this.orderReturn.isSuperUser) {
        reasons.push({ text: this.t('orderReturnReasonDropdownOption5'), value: 5 })
        reasons.push({ text: this.t('orderReturnReasonDropdownOption6'), value: 6 })
      }

      return reasons
    },
    defaultRepaymentOption() {
      if (!this.orderReturn.isBillableClient) {
        return '2'
      }

      return '1'
    },
    dontShowReturnShipping() {
      // Customers should not be able to create an RMA for ReturnWrongArticleRecommendation, Complaint and TransportDamageComplaint
      if (this.selectedReturnRows && (this.selectedReturnRows.some(item => item.returnReasonId === 2 || item.returnReasonId === 3 || item.returnReasonId === 5 || item.returnReasonId === 6) ||
          this.orderReturn.fullOrderReturnReasonID === 2 ||
          this.orderReturn.fullOrderReturnReasonID === 3 ||
          this.orderReturn.fullOrderReturnReasonID === 5 ||
          this.orderReturn.fullOrderReturnReasonID === 6)) {
        return true
      }

      return false
    },
    isUploadedImageRequired() {
      if (this.selectedReturnRows && (this.selectedReturnRows.some(item => item.returnReasonId === 6) ||
          this.orderReturn.fullOrderReturnReasonID === 6)) {
        return true
      }

      return false
    }
  },
  created() {
    this.returnOptions = [
      { id: 2, name: this.t('returnSomeArticles'), description: this.t('returnSomeArticlesDescription') },
      { id: 1, name: this.t('wholeOrder'), description: this.t('wholeOrderDescription') }
    ]
  },
  mounted() {
    if (this.orderNumber !== '') {
      // Load order
      httpService
        .get(`order-return/${this.orderNumber}/order`, { token: this.token })
        .then(response => {
          this.order = response.data
        })
        .catch(error => {
          if (error.response) {
            this.showGeneralErrorMessage = true
          }
        })
        // Load order return
      httpService
        .get(`order-return/${this.orderNumber}`, { token: this.token })
        .then(response => {
          this.orderReturn = response.data

          if (this.orderReturn.erpMessage !== null && this.orderReturn.erpMessage.length > 0) {
            this.showGeneralErrorMessage = true
          }

          if (this.orderReturn === null || this.orderReturn.issueKey === null) {
            this.isReturnActionsOpen = true
          }
        })
        .catch(error => {
          if (error.response) {
            this.showGeneralErrorMessage = true
          }
        })

      // Load issue messages
      httpService
        .get(`order-return/${this.orderNumber}/issue`, { token: this.token })
        .then(response => {
          this.issueMessages = response.data.messages
        })
        .catch(error => {
          if (error.response) {
            this.showGeneralErrorMessage = true
          }
        })
    }

    this.subscribe('order-return-rows-selection-updated', rows => {
      this.selectedReturnRows = rows
    })

    this.subscribe('order-return-general-error', () => {
      this.showGeneralErrorMessage = true
    })

    this.subscribe('order-return-superuser-updated', superuserOptions => {
      this.orderReturn.shippingCost = superuserOptions.shippingCost
      this.orderReturn.shippingKey = superuserOptions.shippingKey
      this.orderReturn.shippingAgent = superuserOptions.shippingAgent
      this.orderReturn.shippingAgentService = superuserOptions.shippingAgentService
      this.orderReturn.documentToCustomer = superuserOptions.documentToCustomer
      this.orderReturn.rma = superuserOptions.rma
      this.orderReturn.createConsignmentNote = superuserOptions.createConsignmentNote
      this.orderReturn.consignmentNoteUrl = superuserOptions.consignmentNoteUrl
      this.orderReturn.handleShippingMyself = superuserOptions.handleShippingMyself
      this.orderReturn.shippingQuoteRequested = superuserOptions.shippingQuoteRequested

      if (superuserOptions.createOrderReturnAndRma) {
        this.createOrderReturn()

        if (this.orderReturn.shippingQuoteRequested !== 'Kunden har BEGÄRT OFFERT för returfrakt') {
          this.creatingRma = true
        }

        this.createRmaAlongWithIssue = false
      }
    })

    this.subscribe('order-return-superuser-rma-created', superuserOptions => {
      this.isSuperuserSectionOpen = false

      if (superuserOptions.erpMessage !== null && superuserOptions.erpMessage.length > 0) {
        this.showGeneralErrorMessage = true
      }
    })

    this.subscribe('order-return-contact-info-updated', customer => {
      this.customerRepresentativeFirstName = customer.firstName
      this.customerRepresentativeLastName = customer.lastName
      this.customerRepresentativeTelephoneNumber = customer.phone
      this.customerRepresentativeEmailAddress = customer.email
    })

    this.subscribe('order-return-file-uploaded', (response) => {
    })

    this.subscribe('order-return-file-upload-updated', newUploadedFiles => {
      this.uploadedFiles = newUploadedFiles
      this.$refs.observer.validate()
    })
  },
  methods: {
    createOrderReturn() {
      this.$refs.observer.validate().then((valid) => {
        if (valid) {
          document.body.scrollTop = 0 // For Safari
          document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera

          const products = _.map(this.selectedReturnRows, item => {
            return { itemId: item.artNr, quantity: item.quantity, returnReasonId: item.returnReasonId, returnReasonDescription: item.returnReasonDescription, machineType: item.machineName, serialNumber: item.serialNumber }
          })

          const orderReturnJson = {
            orderNumber: this.orderNumber,
            products: products,
            repaymentOptionId: this.repaymentOptionID,
            repaymentBankAccountNumber: this.repaymentBankAccountNumber,
            customerRepresentativeFirstName: this.customerRepresentativeFirstName,
            customerRepresentativeLastName: this.customerRepresentativeLastName,
            customerRepresentativeTelephoneNumber: this.customerRepresentativeTelephoneNumber,
            customerRepresentativeEmailAddress: this.customerRepresentativeEmailAddress,
            returnOptionID: this.returnOptionID,
            fullOrderReturnReasonID: this.orderReturn.fullOrderReturnReasonID,
            fullOrderReturnReasonDescription: this.orderReturn.fullOrderReturnReasonDescription,
            fullOrderReturnMachineType: this.orderReturn.fullOrderReturnMachineType,
            fullOrderReturnSerialNumber: this.orderReturn.fullOrderReturnSerialNumber,
            uploadedFiles: this.uploadedFiles,
            shippingCost: this.orderReturn.shippingCost,
            shippingKey: this.orderReturn.shippingKey,
            shippingAgent: this.orderReturn.shippingAgent,
            shippingAgentService: this.orderReturn.shippingAgentService,
            documentToCustomer: this.orderReturn.documentToCustomer,
            createConsignmentNote: this.orderReturn.createConsignmentNote,
            handleShippingMyself: this.orderReturn.handleShippingMyself && !this.dontShowReturnShipping,
            shippingQuoteRequested: this.orderReturn.shippingQuoteRequested
          }

          httpService.post(`order-return/${this.orderNumber}/create-return?token=${encodeURIComponent(this.token)}`, orderReturnJson).then((response) => {
            this.orderReturn = response.data
            this.orderReturnConfirmationDescription = this.tStatic('orderReturnConfirmationDescription')
            this.orderReturn.statusName = 'Created'
            this.isReturnActionsOpen = false

            httpService
              .get(`order-return/${this.orderNumber}`, { token: this.token })
              .then(response => {
                this.orderReturn = response.data

                this.publish('order-return-created', this.orderReturn)
              })
              .catch(error => {
                if (error.response) {
                  this.showGeneralErrorMessage = true
                }
              })

            httpService
              .get(`order-return/${this.orderNumber}/issue`, { token: this.token })
              .then(response => {
                this.issueMessages = response.data.messages
              })
              .catch(error => {
                if (error.response) {
                  this.showGeneralErrorMessage = true
                }
              })
          })
        }
      })
    },
    setReturnOptionID(id) {
      this.returnOptionID = id
    },
    createNewReturn() {
      this.isReturnActionsOpen = !this.isReturnActionsOpen
    },
    toogleSuperuserSection() {
      this.isSuperuserSectionOpen = !this.isSuperuserSectionOpen
    },
    goBack() {
      window.location.href = '/se/sv/mina-sidor/#Orderhistorik'
    },
    getReturnReasonDescriptionPlaceholder(returnReasonId) {
      if (returnReasonId === 2) {
        return this.t('orderReturnNotReceivedWhatWasOrderedPlaceholder') // 'Beskriv felet, t.ex. vilket artikelnummer du f tt ist llet'
      }

      return this.tStatic('orderReturnReasonDescriptionPlaceholder')
    }
  }
}
</script>

<style lang="scss">
  .main--history-details {
    @include container;
    padding-top: measure(double);
    padding-bottom: measure(double);
  }

  .history-details__top {
    margin-bottom: measure(double);
  }

  .history-details__header-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .history-details__information {
    margin-bottom: measure(half);
  }

  .history-details__phone-link {
    margin-top: measure(quarter);
    color: color(text-blue);
  }

  .history-details__information-box {
    @include body-smaller;
    background-color: color(background-white);
    border: 1px solid color(border-gray);
    padding: measure(half);
  }

  .history-details__information-header {
    @include h3-semi-bold;
    margin-top: 0;
  }

  .history-details__information-details-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: measure(eighth);
  }

  .history-details__information-details-key,
  .history-details__information-details-value {
    flex-basis: 50%;
  }

  .history-details__information-address-row {
    margin-bottom: measure(eighth);
  }

  .history-details-products__top {
    @include body-semi-bold;
    display: flex;
    align-items: center;
    padding: measure(quarter) 0;
  }

  .history-details-products__table {
    margin-bottom: measure(half);
  }

  .history-details-products__summary {
    @include body-smaller;
    background-color: color(background-white);
    border: 1px solid color(border-gray);
    margin-bottom: measure(half);
    padding: measure(half);

    @include media(medium) {
      @include body;
    }
  }

  .history-details-products__summary-row {
    display: flex;
    flex-direction: column;
    margin-bottom: measure(half);

    &:last-child {
      margin-bottom: 0;
    }

    @include media(medium) {
      flex-direction: row;
      margin-bottom: measure(quarter);
    }
  }

  .history-details-products__summary-value {
    @include body-smaller-semi-bold;
    margin-left: 0;
    padding-top: measure(quarter);

    @include media(medium) {
      @include body-smaller-semi-bold;
      margin-left: auto;
      padding-top: 0;
    }
  }

  .history-details-products__summary-value--larger {
    @include body-semi-bold;

    @include media(medium) {
      @include h3-semi-bold;
    }
  }

  .history-details-invoice__container > * {
    vertical-align: middle;
    display: inline;
  }

  .history-details-invoice__number {
    @include reset-link;
    display: flex;
    align-items: center;
    margin-right: measure(quarter);

    & > svg {
      width: 1.4rem;
      height: 1.4rem;
      margin-left: measure(quarter);
    }
  }

  .order-return-container__actions-container {
    display: flex;
    flex-direction: column;

    @include media(medium) {
      flex-direction: row;
      align-items: flex-end;
    }
  }

  .order-return-container__actions-right {
    width: 100%;
    margin-top: 1rem;

    @include media(medium) {
      max-width: 24rem;
      width: 100%;
      margin-left: auto;
    }
  }

  .order-return-container__action-button {
    width: 100%;
  }

  .order-return__top-grid {
    margin-bottom: 1.875rem;
    display: block;
  }

  .order-return-status-heading {
    margin-top: 2.5rem;
    margin-bottom: 0.5rem;
  }

  .order-return-repayment {
    margin-bottom: measure(half);
  }

  .order-return-message {
    margin-bottom: 1.25rem;
  }

  .order-return-repayment-info {
    border: 1px solid #44B1FA;
    margin-bottom: 1.25rem;
    padding: 0.625rem !important;
    max-width: 54rem;
  }

  .order-return-container__section-heading {
    font-family: Open Sans, sans-serif;
    font-weight: 600;
    font-size: 1.5em;
    margin-top: 2rem;
    margin-bottom: .4rem;
  }

  .order-return-container__radio-buttons {
    display: flex;
    flex-direction: row;
  }

  .order-return-container__radio-buttons > .radio {
    margin-right: 1rem;
    border: 1px solid #dfdfdf;
    padding: 1rem;
  }

  .order-return-container_products {
    margin-top: 1rem;
  }

  .order-return-container__full-order {
    margin-top: 1rem;
  }

  .new-return__toggler, .superuser-section__toggler {
    margin-top: 2rem;
    font-size: 1.5em !important;
  }

  .new-return__toggler > svg,, .superuser-section__toggler > svg {
    margin-right: .75rem;
  }

  .superuser-section__toggler {
    margin-bottom: 2rem;
  }

  .create-rma-along-with-issue {
    margin-bottom: 1.25rem;
  }

  .dropdown__container {
    z-index: auto !important;
  }

  .my-pages-template__action {
    position: static;
  }
</style>
